module.exports = __webpack_public_path__ + "static/img/bg3.5a9ef3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg3.png
// module id = +f5Z
// module chunks = 0